var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{attrs:{"id":"stripoSettingsContainer"}},[_vm._v("Loading...")])]),_c('b-col',{attrs:{"cols":"6"}},[_c('div',{attrs:{"id":"stripoPreviewContainer"}})])],1),_c('button',{on:{"click":_vm.save}},[_vm._v("save")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }